async function resolveSliceModel(args) {
  if ("model" in args) {
    return args.model;
  }
  const { model } = await args.actions.readSliceModel({
    libraryID: args.libraryID,
    sliceID: args.sliceID
  });
  return model;
}
export {
  resolveSliceModel
};
//# sourceMappingURL=resolveSliceModel.js.map
